import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import DomeGallery from "../../components/animations/DomeGallery";

const CSRPage: React.FC = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Corporate Social Responsibility | AquarLabs</title>
                <meta name="description" content="AquarLabs' commitment to Corporate Social Responsibility. Making a positive impact through community outreach, sustainability initiatives, and social programs." />
                <meta name="keywords" content="CSR, corporate social responsibility, community outreach, sustainability, social impact, AquarLabs" />
            </Helmet>
            <div className="about-page inner-page">
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="Corporate Social Responsibility" pagesub="CSR" parentPage="About" parentLink="/about-us" />

                        {/* Quote Section */}
                        <section style={{
                            padding: "80px 0 40px",
                            background: "linear-gradient(180deg, rgba(0, 2, 15, 0.9) 0%, rgba(0, 2, 15, 0.5) 100%)",
                            textAlign: "center"
                        }}>
                            <div className="container">
                                <div style={{ maxWidth: "900px", margin: "0 auto" }}>
                                    <blockquote style={{
                                        fontSize: "2rem",
                                        fontStyle: "italic",
                                        color: "#fff",
                                        lineHeight: "1.6",
                                        fontWeight: "300",
                                        marginBottom: "30px"
                                    }}>
                                        "The best way to find yourself is to lose yourself in the service of others."
                                    </blockquote>
                                    <cite style={{
                                        fontSize: "1.1rem",
                                        color: "#fc9038",
                                        fontStyle: "normal"
                                    }}>
                                        — Mahatma Gandhi
                                    </cite>
                                    <p style={{
                                        marginTop: "40px",
                                        fontSize: "1.15rem",
                                        color: "rgba(255,255,255,0.8)",
                                        lineHeight: "1.8"
                                    }}>
                                        At AquarLabs, we believe that technology should serve humanity. Our CSR initiatives focus on
                                        education, community development, and creating opportunities for those who need them most.
                                        Together, we're building a future where innovation and compassion go hand in hand.
                                    </p>
                                </div>
                            </div>
                        </section>

                        {/* Gallery Section with Vignette Effect */}
                        <section style={{
                            width: "100%",
                            maxWidth: "100vw",
                            height: "100vh",
                            minHeight: "700px",
                            position: "relative",
                            background: "#00020f",
                            overflow: "hidden"
                        }}>
                            {/* Vignette overlay for soft blurred edges */}
                            <div style={{
                                position: "absolute",
                                inset: 0,
                                pointerEvents: "none",
                                zIndex: 10,
                                background: `
                                    radial-gradient(ellipse 85% 85% at 50% 50%, transparent 35%, rgba(0, 2, 15, 0.4) 60%, rgba(0, 2, 15, 0.9) 100%),
                                    linear-gradient(to top, rgba(0, 2, 15, 1) 0%, transparent 20%),
                                    linear-gradient(to bottom, rgba(0, 2, 15, 1) 0%, transparent 15%),
                                    linear-gradient(to left, rgba(0, 2, 15, 0.9) 0%, transparent 15%),
                                    linear-gradient(to right, rgba(0, 2, 15, 0.9) 0%, transparent 15%)
                                `
                            }} />
                            <DomeGallery
                                grayscale={true}
                                imageBorderRadius="16px"
                                openedImageBorderRadius="24px"
                                openedImageWidth="550px"
                                openedImageHeight="420px"
                                overlayBlurColor="#00020f"
                                fit={1.8}
                                fitBasis="auto"
                                minRadius={1000}
                                segments={28}
                                maxVerticalRotationDeg={20}
                            />
                        </section>

                        {/* Impact Section */}
                        <section style={{ padding: "80px 0", background: "rgba(0,2,15,0.8)" }}>
                            <div className="container">
                                <div className="text-center" style={{ marginBottom: "50px" }}>
                                    <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase", letterSpacing: "2px" }}>Our Impact</span>
                                    <h2 style={{ fontSize: "2.5rem", margin: "15px 0 20px", color: "#fff" }}>Making a Difference Together</h2>
                                </div>
                                <div className="row">
                                    {[
                                        { number: "500+", label: "Students Supported", desc: "Through educational programs and scholarships" },
                                        { number: "15+", label: "Community Events", desc: "Organized annually for social causes" },
                                        { number: "10+", label: "NGO Partners", desc: "Working together for greater impact" },
                                        { number: "3", label: "Countries", desc: "India, Canada & USA initiatives" }
                                    ].map((item, index) => (
                                        <div key={index} className="col-lg-3 col-md-6" style={{ marginBottom: "30px" }}>
                                            <div style={{
                                                background: "rgba(255,255,255,0.03)",
                                                border: "1px solid rgba(252, 144, 56, 0.3)",
                                                borderRadius: "16px",
                                                padding: "40px 30px",
                                                textAlign: "center",
                                                height: "100%"
                                            }}>
                                                <h3 style={{ fontSize: "3rem", color: "#fc9038", marginBottom: "10px", fontWeight: "700" }}>{item.number}</h3>
                                                <h4 style={{ fontSize: "1.2rem", color: "#fff", marginBottom: "10px" }}>{item.label}</h4>
                                                <p style={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.6)", margin: 0 }}>{item.desc}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default CSRPage;